import { render, staticRenderFns } from "./AppointmentGuestsModal.vue?vue&type=template&id=71dae3d6"
import script from "./AppointmentGuestsModal.vue?vue&type=script&lang=js"
export * from "./AppointmentGuestsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports